import { Modal, Select, Spin, message } from "antd"
import { useEffect, useMemo, useRef, useState } from "react"
import { LoadingOutlined } from '@ant-design/icons';
import styles from './alipayModalV2.module.scss'
import API from '@api/api'
import * as _ from "underscore";
import eventBus from '@utils/eventBus';
import Decimal from 'decimal.js'

const formatAmount = (amount) => {
    // 使用正则表达式匹配非零小数
    return amount >= 1 ? parseFloat(amount) : amount
}

const Tips = (props) => {
    const {
        unit, // 0-单月 1-限时特惠 2-包年
        isPowerPackage, // 加油包
        powerAmount,
    } = props

    if (isPowerPackage) return <p className={styles.Tips}>每个加油包有效期为30天，未用完的虹豆将在购买起第30天后清空</p>
    else return (
        <ul className={styles.Tips}>
            <li>支付完成后默认您同意<a target='_blank' href="/会员条款.htm">相关协议条例</a> </li>
            <li>虚拟商品，支付后无法退还</li>
            <li>{unit == 'Month' ? '包月' : unit == 'Quarter' ? '包季' : '包年'}服务有效期为{unit == 'Month' ? '30' : unit == 'Quarter' ? '90' : '365'}天</li>
            <li>会员订购当天可获得 <span>{powerAmount}</span> AI虹豆，服务周期内未用完的虹豆，将在当前服务周期结束时清空</li>
        </ul>
    )
}

const CouponSelect = (props) => {
    const [inited, setInited] = useState()
    const [list, setList] = useState([])
    const [defaultValue, setDefaultValue] = useState()

    useEffect(() => {
        API.getCouponListForPay({
            type: props.type, // =0 套餐 =1 加油包
            id: props.skuId, // 对应类型sku的id
        }).then(res => {
            if (res?.code != 0) return message.error(res.message)
            setList(res.data)
            setDefaultValue(res.data[0]?.bindingId)
            props.onChange(res.data[0]?.bindingId)
        }).finally(() => {
            setInited(true)
        })
    }, [])

    const onChange = (value) => {
        props.onChange(value)
    }

    return (
        <div className={styles.CouponSelectWrap}>
        {
            inited &&
            <Select
                defaultActiveFirstOption
                defaultValue={defaultValue}
                className={styles.CouponSelect}
                popupClassName={styles.CouponSelectPopup}
                fieldNames={{ label: 'name', value: 'bindingId' }}
                options={list}
                onChange={onChange}
            />
        }
        </div>
    )
}

const IFrameRender = (props) => {
    const { actived, payUrl } = props
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(payUrl)
    }, [])

    return (
        <iframe ref={alipayFrameRef}
            className={styles.payFrame}
            style={{ display: actived ? 'block' : 'none' }}
            // srcDoc={payUrl}
            width="200"
            height="200"
            marginWidth={0}
            marginHeight={0}
            frameBorder="0"
            border="0"
            scrolling="no"
        ></iframe>
    )
}

const LeftWrap = (props) => {
    // console.log('leftwrap', props)

    const unit = useMemo(() => {
        return props.selectedItem.unit
    }, [props.selectedItem])

    const couponPrice = useMemo(() => {
        if (!props.selectedItem.price || !props.selectedItem.orderAmount) return 0
        return new Decimal(props.selectedItem.price).sub(new Decimal(props.selectedItem.orderAmount))
    }, [props.selectedItem.price, props.selectedItem.orderAmount])

    const couponPriceEqZero = useMemo(() => {
        return !new Decimal(couponPrice).eq(new Decimal('0'))
    }, [couponPrice])

    return (
        <>
        <p className={styles.PayTitle}>请打开支付宝扫码支付</p>
        <div className={styles.iframeBox}>
            <div className={styles.iframeWrap}>
                {
                    props.frameList.map((item, index) => (
                        item &&
                        <IFrameRender
                            key={`${item.tradeId}`}
                            planId={props.planId}
                            planNumber={item.number}
                            payUrl={item.payUrl}
                            actived={props.selectedIndex == index}
                        />
                    ))
                }
                <div className={styles.iframePlaceholderWrap}>
                    <Spin
                        wrapperClassName={styles.iframePlaceholderSpin}
                        spinning={true}
                        size="large"
                        // indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
                    >
                        <div className={styles.iframePlaceholder}></div>
                    </Spin>
                </div>
            </div>
        </div>
        <div className={`${styles.PayPrice} ${props.isAlone && styles.alone}`}>
        {
            props.selectedItem.orderAmount && 
            <>
            <span>扫码支付：</span>
            <p>
                <span>￥</span>
                <span>{formatAmount(props.selectedItem.orderAmount)}</span>
                { !props.isPowerPackage && <span> / {unit == 'Month' ? '月' : unit == 'Quarter' ? '季' : unit == 'Year' ? '年' : ''}</span> }
            </p>
            </>
        }
        </div>
    
        {
            couponPriceEqZero &&
            <p className={styles.CouponPrice}>
            {
                props.selectedItem.orderAmount &&
                <span>{ props.couponId ? '优惠' : '抵扣' } ￥ {`${formatAmount(couponPrice)}`}</span>
            }
            </p>
        }
        {
            !props.isAlone && 
            <ul className={styles.Tips} style={{ width: 'auto' }}>
                <li>支付完成后默认您同意<a target='_blank' href="/会员条款.htm">相关协议条例</a> </li>
            </ul>
        }
        { props.isAlone && <CouponSelect type={props.isPowerPackage ? 1 : 0} skuId={props.selectedItem.id} onChange={props.onCouponChange} /> }
        { props.isAlone && <Tips unit={unit} isPowerPackage={props.isPowerPackage} powerAmount={props.selectedItem.powerAmount} /> }
        </>
    )
}

const RightWrap = (props) => {
    const type = useMemo(() => {
        return props.selectedItem.type
    }, [props.selectedItem])

    return (
        <>
        {
            props.items.map((item, index) => (
                <div
                    key={item.id}
                    className={`${styles.PayItemWrap}`}
                    onClick={() => props.toPay(index)}
                >
                    <div className={`${styles.PayItem} ${props.selectedIndex == index && styles.actived}`}>
                        <div className={styles.numberText}>{item.numberText}</div>
                        <div className={styles.tips}>{item.tips}</div>
                        <div className={styles.priceBox}>
                            <span>￥</span>
                            {
                                <span>{formatAmount(item.price)}</span>
                            }
                        </div>
                    </div>
                </div>
            ))
        }
        <CouponSelect type={props.isPowerPackage ? 1 : 0} skuId={props.selectedItem.id} onChange={props.onCouponChange} />
        <Tips type={type} isPowerPackage={props.isPowerPackage} powerAmount={props.selectedItem.powerAmount} />
        </>
    )
}

const AlipayContent = (props) => {
    //-----------new----------
    // type: 0-包月；1-包季；2-包年
    // description "捕光逐影"
    // level "basic"
    // name "PSAI 捕光逐影"
    // powerAmount 1000
    // price "48.00"
    // supportDevices 1
    // unit "Month"


    // description :  "约可生成 100 张图片"
    // discount :  "0.50" // 折扣
    // discountPrice :  "12.50" // 折扣价
    // id :  1
    // name :  "1000点加油包"
    // numberText :  "1000虹豆"
    // powerAmount :  1000 // 虹豆
    // price :  "25.00" // 原价
    // tips :  "约可生成 100 张图片, 当月有效"
    // unit :  "Month"
    const {isPowerPackage, defaultSelectedIndex = 0}  = props
    const isMounted = useRef(false) // 判断组件是否已销毁
    const [inited, setInited] = useState()
    const selectedIndexRef = useRef()
    const [selectedIndex, setSelectedIndex] = useState()
    const selectedItemRef = useRef()
    const [selectedItem, setSelectedItem] = useState()
    const idRef = useRef()
    const [items, setItems] = useState([])
    const [frameList, setFrameList] = useState([])
    const frameListRef = useRef([])
    const diyPowerRef = useRef(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        const beforeunloadHandle = () => {
            removeAllTrade(1)
        }
        window.addEventListener('beforeunload', beforeunloadHandle)

        return () => {
            isMounted.current = false
            removeAllTrade(1)
            window.removeEventListener('beforeunload', beforeunloadHandle)
        }
    }, [])

    // 优惠券
    const couponIdRef = useRef()
    const [couponId, setCouponId] = useState()
    const onCouponChange = (value) => {
        couponIdRef.current = value
        setCouponId(value)
    }

    // 删除订单，释放优惠券
    const removeAllTrade = (payStatusCheck=0, excludeIndex) => {
        const deletePromiseList = []
        for (let i = 0; i < frameListRef.current.length; i++) {
            if (i == excludeIndex) continue
            if (frameListRef.current[i]) {
                const tradeId = frameListRef.current[i]?.tradeId
                if (tradeId) deletePromiseList.push(API.removeOrder({tradeId: tradeId, payStatusCheck}))
                frameListRef.current[i] = null
            }
        }
        if (deletePromiseList.length == 0) return Promise.resolve(true) 
        return Promise.allSettled(deletePromiseList).then(res => {
            return Promise.resolve(true)
        }).catch(err => {
            console.error(err)
            return Promise.resolve(false)
        })
    }

    // 初始化
    useEffect(() => {
        isMounted.current = true
        idRef.current = props.alipayItems?.id
        diyPowerRef.current = props.alipayItems?.diyPower || 0
        setItems(props.alipayItems?.list || [])
        selectedIndexRef.current = defaultSelectedIndex
        setSelectedIndex(defaultSelectedIndex)
        selectedItemRef.current = (props.alipayItems?.list || [])[defaultSelectedIndex]
        setSelectedItem(selectedItemRef.current)
        frameListRef.current = new Array((props.alipayItems?.list || []).length)
        setFrameList(frameListRef.current)
        checkStatusFunc()
        setInited(true)
    }, [props.alipayItems])

    useEffect(() => {
        if (selectedIndex == undefined) return
        if (couponId == undefined) return
        setLoading(true)
        removeAllTrade().then(() => {
            const func = isPowerPackage ?
                API.subscribePowerPackage({ // 加油包
                    skuId: selectedItemRef.current.id,
                    couponBindingId: couponId,
                }) :
                diyPowerRef.current > 0 ?
                API.subscribePlan({ // 随心配
                    skuId: idRef.current,
                    number: 1,
                    type: selectedItemRef.current.type,
                    couponBindingId: couponId,
                    diyPower: diyPowerRef.current,
                }) : 
                API.subscribePlan({ // 套餐
                    skuId: idRef.current,
                    number: 1,
                    type: selectedItemRef.current.type,
                    couponBindingId: couponId,
                })
            func.then(res => {
                if (res.code != 0) throw new Error(res.message)
                const payUrl = res.data.payUrl
                const tradeId = res.data.tradeId
                const orderAmount = res.data.dealAmount
                frameListRef.current[selectedIndex] = {
                    ...selectedItemRef.current,
                    payUrl,
                    tradeId,
                    orderAmount
                }
                frameListRef.current = [...frameListRef.current]
                setFrameList(frameListRef.current)
                selectedItemRef.current = frameListRef.current[selectedIndex]
                setSelectedItem(selectedItemRef.current)
            }).catch(err => {
                message.warning(err.message)
                props.closeFunc && props.closeFunc()
            }).finally(() => {
                setLoading(false)
            })
        })
    }, [selectedIndex, couponId])

    // 定时查询订单状态，处理订单完成或超时的逻辑
    const checkStatusFunc = _.throttle(() => {
        // 仅查询当前选择的tradeId
        const tradeIdList = frameListRef.current
            .filter((item,index) => (index == selectedIndexRef.current) && !!item?.tradeId)
            .map(item => item.tradeId)
        if (tradeIdList.length == 0) {
            if (isMounted.current) checkStatusFunc()
            return
        }
        API.paymentOrderStatus({
            tradeList: tradeIdList
        }).then(res => {
            if (res.code == 0) {
                for (let item of res.data) {
                    if (item.status == 'success') { // 关闭页面，并提示支付成功
                        console.log('订单支付成功', item.tradeId)
                        props.closeFunc && props.closeFunc()
                        props.refreshFunc && props.refreshFunc()
                        message.success('支付成功')
                        eventBus.emit('updatePower')
                        return
                    } else if (item.status == 'closed') { // 订单已关闭，需要刷新订单
                        console.log('订单关闭，刷新订单', item.tradeId)
                        refreshTrade(item.tradeId)
                    }
                }
            }
        }).finally(() => {
            if (isMounted.current) checkStatusFunc()
        })
    }, 1000)

    const refreshTrade = (tradeId) => {
        for (let i = 0; i < frameListRef.current.length; i++) {
            const item = frameListRef.current[i]
            if (item && item.tradeId == tradeId) {
                const func = isPowerPackage ?
                    API.subscribePowerPackage({
                        skuId: item.id,
                        couponBindingId: couponIdRef.current,
                    }) :
                    diyPowerRef.current > 0 ?
                    API.subscribePlan({
                        skuId: idRef.current,
                        number: item.number,
                        couponBindingId: couponIdRef.current,
                        diyPower: diyPowerRef.current,
                    }) : 
                    API.subscribePlan({
                        skuId: idRef.current,
                        number: item.number,
                        couponBindingId: couponIdRef.current,
                    })
                return func.then(res => {
                    if (res.code != 0) throw new Error(res.message)
                    const payUrl = res.data.payUrl
                    const tradeId = res.data.tradeId
                    const orderAmount = res.data.dealAmount
                    frameListRef.current[i] = {
                        ...item,
                        payUrl,
                        tradeId,
                        orderAmount
                    }
                    frameListRef.current = [...frameListRef.current]
                    setFrameList(frameListRef.current)
                    selectedItemRef.current = frameListRef.current[i]
                    setSelectedItem(selectedItemRef.current)
                }).catch(err => {
                    message.warning(err.message)
                    props.closeFunc && props.closeFunc()
                })
            }
        }
    }

    const toPay = (index) => {
        selectedIndexRef.current = index
        setSelectedIndex(index)
        selectedItemRef.current = items[index]
        setSelectedItem(selectedItemRef.current)
    }

    const isAlone = useMemo(() => {
        return items.length <= 1
    }, [items])

    return (
        <div className={styles.AlipayBody}>
        {
            inited &&
            <div className={`${styles.AlipayLeftWrap} ${isAlone && styles.alone}`}>
                <LeftWrap
                    isPowerPackage={isPowerPackage}
                    frameList={frameList}
                    selectedIndex={selectedIndex}
                    selectedItem={selectedItem}
                    planId={idRef.current}
                    isAlone={isAlone}
                    couponId={couponId}
                    onCouponChange={onCouponChange}
                />
            </div>
        }
        {
            inited &&
            !isAlone &&
            <div className={styles.AlipayRightWrap}>
                <RightWrap
                    isPowerPackage={isPowerPackage}
                    items={items}
                    selectedIndex={selectedIndex}
                    selectedItem={selectedItem}
                    toPay={toPay}
                    couponId={couponId}
                    onCouponChange={onCouponChange}
                />
            </div>
        }
        </div>
    )
}

const AlipayModalV2 = (props) => {
    const [name, setName] = useState('')
    const [open, setOpen] = useState()

    // 初始化
    useEffect(() => {
        setOpen(props.open)
        setName(props.alipayItems?.name)
    }, [props.open, props.alipayItems])

    const isAlone = useMemo(() => {
        return props.alipayItems?.list.length <= 1
    }, [props.alipayItems?.list])

    return (
        <Modal
            centered
            title={`购买${name}`}
            open={open}
            closeIcon={<img src={require('@assets/images/icon_close.png')} />}
            destroyOnClose
            footer={null}
            wrapClassName={`${styles.AlipayModalV2} ${isAlone && styles.Small}`}
            onCancel={() => props.closeFunc()}
        >
            <AlipayContent open={open} {...props} />
        </Modal>
    )
}

export default AlipayModalV2